import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

export default function AdmissionsCTA() {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl overflow-hidden gradient-deep-blue">
          {/* Decorative blobs */}
          <div className="absolute -top-16 -right-16 w-96 h-96 bg-yellow-400/20 rounded-full blur-3xl animate-blob" />
          <div className="absolute -bottom-20 -left-20 w-96 h-96 bg-blue-300/20 rounded-full blur-3xl animate-blob" style={{ animationDelay: "3s" }} />
          {/* Grid */}
          <div
            className="absolute inset-0 opacity-[0.07]"
            style={{
              backgroundImage:
                "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
              backgroundSize: "40px 40px",
            }}
          />

          <div className="relative grid md:grid-cols-2 gap-10 p-10 md:p-16 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-yellow-400/15 border border-yellow-400/30 text-yellow-300 text-xs font-bold tracking-wider uppercase mb-6">
                <Sparkles className="h-3.5 w-3.5" />
                Admissions Open
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-5">
                3.5 years German Technical Training Course
              </h2>
              <p className="text-slate-200 leading-relaxed mb-8">
                For 10th/12th Pass students (all streams). Get certified by HWK Koblenz, Germany.
                Earn stipend from Year 2 onwards. Build a global career in technology.
              </p>
              <Link
                to="/admissions"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-lg btn-primary group"
              >
                Apply for Admission
                <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition" />
              </Link>
            </div>
            <div className="relative">
              <div className="grid grid-cols-2 gap-4">
                {[
                  ["3.5", "Years", "Course Duration"],
                  ["100%", "German", "Curriculum"],
                  ["\u20b95-15K", "Stipend", "Year 2 onwards"],
                  ["95%", "Placement", "Assistance"],
                ].map(([n, t, s], i) => (
                  <div
                    key={i}
                    className="bg-white/8 backdrop-blur border border-white/15 rounded-2xl p-5 hover:bg-white/15 transition group"
                  >
                    <div className="text-3xl font-bold text-yellow-400 group-hover:scale-110 origin-left transition">{n}</div>
                    <div className="text-sm font-semibold text-white mt-1">{t}</div>
                    <div className="text-xs text-slate-300 mt-0.5">{s}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
